export const TelegramIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3334 2.66675L7.33337 8.66675"
      stroke="#AAB3D0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 2.66675L9.33337 13.3334L7.33337 8.66675L2.66671 6.66675L13.3334 2.66675Z"
      stroke="#AAB3D0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
